class ProductAddons extends HTMLElement {
  constructor () {
    super()
    this.totalEl = this.querySelector('.addon-total-price')
    this.querySelectorAll('.addon-checkbox').forEach(checkbox => {
      checkbox.addEventListener('change', () => this.updateTotal())
    })
  }

  updateTotal () {
    const total = this.getSelected().reduce((sum, a) => sum + a.price, 0)
    if (this.totalEl) this.totalEl.textContent = `₹${total}`
  }

  getSelected () {
    const selected = []
    this.querySelectorAll('.addon-checkbox:checked').forEach(checkbox => {
      selected.push({
        id: Number(checkbox.dataset.variantId),
        price: Number(checkbox.dataset.price)
      })
    })
    return selected
  }

  reset () {
    this.querySelectorAll('.addon-checkbox:checked').forEach(cb => { cb.checked = false })
    this.updateTotal()
  }
}
customElements.define('product-addons', ProductAddons)


document.addEventListener('DOMContentLoaded', () => {
  const atcButton = document.querySelector('button[name="add"]')
  const cartContainer = document.querySelector('cart-container')

  if (!atcButton || !cartContainer) return

  const productForm = atcButton.closest('form')
  if (!productForm) return

  const addonsBlock = document.querySelector('product-addons')

  productForm.addEventListener('submit', async (e) => {
    e.preventDefault()
    e.stopImmediatePropagation()

    const formData = new FormData(productForm)
    const mainVariantId = Number(formData.get('id'))
    const qty = Number(formData.get('quantity')) || 1
    const groupId = `grp_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`

    const parentProductTitle = productForm.dataset.productTitle || document.title

    const items = []

    if (addonsBlock) {
      addonsBlock.getSelected().forEach(addon => {
        items.push({
          id: addon.id,
          quantity: 1,
          properties: { 
            '_addon_group': groupId, 
            '_parent': 'addon',
            '_product': parentProductTitle
          }
        })
      })
    }

    items.push({
      id: mainVariantId,
      quantity: qty,
      properties: { 
        '_addon_group': groupId, 
        '_parent': 'main' 
      }
    })

    await cartContainer.add({ items })
    if (addonsBlock) addonsBlock.reset()
  }, true)

  document.addEventListener('click', (e) => {
    const removeBtn = e.target.closest('.btn-line-item-remove')
    if (!removeBtn) return

    const removedKey = removeBtn.dataset.lineItemKey
    if (!removedKey) return

    e.preventDefault()
    e.stopImmediatePropagation()

    handleRemove(removedKey, cartContainer)
  }, true)
})


async function handleRemove (removedKey, cartContainer) {
  try {
    const cartRes = await fetch('/cart.js')
    const cart = await cartRes.json()

    const removedItem = cart.items.find(item => item.key === removedKey)
    if (!removedItem) return

    let linkedAddons = []
    if (removedItem.properties?._parent === 'main') {
      const groupId = removedItem.properties?._addon_group
      if (groupId) {
        linkedAddons = cart.items.filter(item =>
          item.properties?._addon_group === groupId &&
          item.properties?._parent === 'addon'
        )
      }
    }

    const updates = {}
    updates[removedKey] = 0
    linkedAddons.forEach(addon => { updates[addon.key] = 0 })

    const response = await fetch(`${window.Shopify.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates,
        sections: ['cart-count-badge', 'offcanvas-cart'],
        sections_url: window.location.pathname
      })
    })

    const data = await response.json()

    if (response.ok) {
      cartContainer.reloadCartElements(data.sections)
    }
  } catch (err) {
    console.error('Addon cleanup error:', err)
  }
}